import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import Animate from '../../../shared/animation';
import map from 'lodash/map';

import { enum as userTypes } from '../../../../../../enums/user-types';
import Avatar from '../../../../modules/shared/avatar';

lessRequire('modules/tickets/item/components/table.less');

const PostsTable = ({ thread, user, intl }) => (
	<Animate>
		<table className="dashboard-table ticket-answer-table">
			<tbody className="dashboard-table__body">
				{getRows(thread, user, intl)}
			</tbody>
		</table>
	</Animate>
);

const getRows = (thread, user, intl) => {
	return thread.posts.map(post => (
		<tr key={post.id}>
			<td className="user-avatar">
				{ post.avatar ?
					<Avatar className="user-avatar__wrap" src={post.avatar} /> : (
						<div className="user-avatar__wrap">
							{ post.author === userTypes.affiliate ?
								<div className="default-web-avatar"></div> :
								<div className="default-support-avatar"></div> }
						</div>
					)
				}

			</td>
			<td className="user-info">
				<span className="user-info__name font-proxima-nova-semibold">{getPostAuthor(post, intl)}</span>
				<span className="user-info__datetime">
					{moment(post.created_at).format('DD.MM.YY')}
					<i>{moment(post.created_at).format('HH:mm')}</i>
				</span>
			</td>
			<td className="answer">
				<div className="answer_text">{post.text}</div>
				<div className="answer_attachment">
					{!!post.attachments &&
						map(post.attachments, file => {
							return <p key={`${file.path}`}><a href={file.path} target="_blank">{file.name}</a></p>;
						})}
				</div>
			</td>
		</tr>
	));
};

const getPostAuthor = (post, intl) => {
	if (post.author === userTypes.affiliate) {
		return intl('Вы');
	} else if (post.author === userTypes.admin) {
		return `${intl('Поддержка')} (${post.name})`;
	}
};

PostsTable.propTypes = {
	thread: PropTypes.object,
	user: PropTypes.object,
	threadVote: PropTypes.func,
	intl: PropTypes.func
};

export default PostsTable;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/item/components/table.js